import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b50ef614&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b50ef614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50ef614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\siva-dev-all\\sivadm-admin-multi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b50ef614')) {
      api.createRecord('b50ef614', component.options)
    } else {
      api.reload('b50ef614', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b50ef614&scoped=true&", function () {
      api.rerender('b50ef614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Breadcrumb/index.vue"
export default component.exports